import QueryParamsUtil from 'api/utils/query-params-util'
import axios from 'axios'


const API_PATH = 'api/v2/admins/merchants/products'

const MerchantProductsApiV2 = {
  /**
   * Get list of `Merchant Product`
   * @param {object} params uri parameter
   * @return {object} Collection of `Merchant`
   */
  get: async ({ tableState, additionalFilters }) => {
    const params = QueryParamsUtil.format(tableState, additionalFilters)
    const path   = API_PATH

    const response = axios.get(path, { params })
    return response
  },

  /**
   * Change Merchant::Product.photo_edited_status to 'completed'
   * Inovke `PATCH api/v2/admins/merchant/products/photo_edited`
   * @param {string} sku - Merchant Inventory Batch Item sku
   * @param {number} inventory_batch_id - Merchant Inventory Batch Id
   */
  photoEdited: async ({ sku, inventory_batch_id }) => {
    const endpoint = `${API_PATH}/photo_edited`
    const payload  = {
      sku                : sku,
      inventory_batch_id : inventory_batch_id
    }

    const response = axios.patch(endpoint, payload)
    return response
  },

  /**
   * Change Merchant::Product.photography_status to 'completed'
   * Inovke `PATCH api/v2/admins/merchant/products/photography`
   * @param {string} sku - Merchant Inventory Batch Item sku
   * @param {number} inventory_batch_id - Merchant Inventory Batch Id
   */
  photographyCompleted: async ({ sku, inventory_batch_id }) => {
    const endpoint = `${API_PATH}/photography_completed`
    const payload  = {
      sku                : sku,
      inventory_batch_id : inventory_batch_id
    }

    const response = axios.patch(endpoint, payload)
    return response
  },

  /**
   * Change Merchant::Product.photo_upload_status to 'completed'
   * Inovke `PATCH api/v2/admins/merchant/products/photo_upload`
   * @param {string} id - Merchant Product ID
   */
  photo_upload_completed: async ({ id }) => {
    const endpoint = `${API_PATH}/${id}/photo_upload_completed`

    const response = axios.patch(endpoint)
    return response
  },

  /**
   * Show Merchant Product by specific id
   * Inovke `GET api/v2/admins//merchant/products/:id`
   * @param {number} id Merchant Product's ID
   */
  show: async (id) => {
    const path = `${API_PATH}/${id}`

    const response = await axios.get(path)
    return response
  },

  /**
   * Change Merchant::Product.photo_curation_status by inputted params
   * Inovke `PATCH api/v2/admins/merchant/products/:id/photo_curation`
   * @param {number} id  - Merchant Product Id
   * @param {string} photo_curation_status - Merchant Product PhotoCurationStatus
   */
  photoCurate: async ({
    id,
    photo_curation_status
  }) => {
    const endpoint = `${API_PATH}/${id}/photo_curation`
    const payload  = {
      photo_curation_status: photo_curation_status
    }

    const response = axios.patch(endpoint, payload)
    return response
  },

  /**
   * get variants from merchant product
   * Inovke `PATCH api/v2/admins/merchant/products/:id/variants`
   * @param {number} merchant_product_id - Merchant::Product Id
   */
  getVariants: async ({
    tableState,
    additionalFilters,
    merchant_product_id
  }) => {
    const params = QueryParamsUtil.format(tableState, additionalFilters)
    const path   = `${API_PATH}/${merchant_product_id}/variants`

    const response = axios.get(path, { params })
    return response
  },

  /**
   * Change Merchant::Product.live_process_status to `completed`
   * Inovke `PATCH api/v2/admins/merchant/products/:id/make_live`
   * @param {number} id - Merchant Product Id
   */
  makeLive: async ({ id }) => {
    const endpoint = `${API_PATH}/${id}/make_live`
    const response = axios.patch(endpoint)
    return response
  },

  /**
   * Change Merchant::Product photography_status back to 'pending'
   * Inovke `PATCH api/v2/admins/merchant/products/photography_pending`
  **/
  photographyPending: async ({ sku, inventory_batch_id }) => {
    const endpoint = `${API_PATH}/photography_pending`
    const payload  = {
      sku                : sku,
      inventory_batch_id : inventory_batch_id
    }
    const response = axios.patch(endpoint, payload)
    return response
  }
}

export default MerchantProductsApiV2
